import { httpCreate } from './http';

const http = httpCreate('/shop/api/product-coupon-activity');

export const productCouponActivity = {
	/**
	 * 直播间关联优惠券列表
	 * @param {number} activityId 直播间ID
	 * @param {*} params
	 * @returns
	 */
	getActivityCoupon(activityId, params) {
		return http.get(`/listByActivityId/${activityId}`, { params });
	},
	/**
	 * 直播间可关联优惠券列表
	 * @param {number} activityId 直播间ID
	 * @param {*} params
	 * @returns
	 */
	getActicityRelateCoupon(activityId, params) {
		return http.get(`/toRelateList/${activityId}`, { params });
	},
	/**
	 * 移除直播间优惠卷关联
	 * @param {number} couponId 优惠卷ID
	 * @param {number} activityId 直播间ID
	 * @returns
	 */
	deleteProductCouponActivity(couponId, activityId) {
		return http.put(`/${couponId}/remove/${activityId}`);
	},
	/**
	 * 直播间关联优惠券
	 * @param {number} activityId 直播间ID
	 * @param {array} data 优惠卷id的列表
	 * @returns
	 */
	putActicityRelateCoupon(activityId, data) {
		return http.put(`/relate/${activityId}`, data);
	},
	/**
	 * 直播间推送优惠券
	 * @param {number} activityId 直播间ID
	 * @param {*} data
	 */
	postActivityCoupon(activityId, data) {
		return http.post(`/push/${activityId}`, data);
	},
};
